import api from "../api";

// Owner endpoints (/transfers/{id}/...) and request-link endpoints (/transfers/public/{token}/...)
// share the same upload sub-paths, so the uploader only needs a base path.
export const ownerUploadBase = (transferId) => `/transfers/${transferId}`;
export const publicUploadBase = (token) => `/transfers/public/${encodeURIComponent(token)}`;

export const transfersApi = {
  create: (payload) => api.post("/transfers", payload),
  list: (status = "active") => api.get("/transfers", { params: { status } }),
  stats: () => api.get("/transfers/stats"),
  get: (id) => api.get(`/transfers/${id}`),
  remove: (id) => api.delete(`/transfers/${id}`),
  finalize: (id) => api.post(`/transfers/${id}/finalize`),
  ownerFileUrl: (id, fileId) => `${api.defaults.baseURL}/transfers/${id}/files/${fileId}/download`,
  ownerZipUrl: (id) => `${api.defaults.baseURL}/transfers/${id}/download-zip`,

  getPublic: (token) => api.get(publicUploadBase(token)),
  publicFileUrl: (token, fileId) => `${api.defaults.baseURL}${publicUploadBase(token)}/files/${fileId}`,
  publicZipUrl: (token) => `${api.defaults.baseURL}${publicUploadBase(token)}/zip`,
  finalizePublic: (token, fileIds) => api.post(`${publicUploadBase(token)}/finalize`, { file_ids: fileIds }),
};
